import React from "react"
import { AppFunctionComponent } from "../../../../../types"
import useTranslationHook from "../../../../../hooks/use-translation.hook"
import {
  SliderButtonStyle,
  StyledControlsContainer,
} from "./quick-start.styled"

export const ControlsPrevIcon: AppFunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.2929 6.05078L7.58594 11.7578L13.2929 17.4648L14.7069 16.0508L10.4139 11.7578L14.7069 7.46478L13.2929 6.05078Z"
      fill="black"
    />
  </svg>
)

export const ControlsNextIcon: AppFunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.70697 17.707L15.414 12L9.70697 6.29297L8.29297 7.70697L12.586 12L8.29297 16.293L9.70697 17.707Z"
      fill="black"
    />
  </svg>
)

interface QuickStartMobileControlsProps {
  handlePrevClick: () => void
  handleNextClick: () => void
  disabledPrev: boolean
  disabledNext: boolean
  color?: string
}

const QuickStartMobileControls: AppFunctionComponent<
  QuickStartMobileControlsProps
> = ({
  handlePrevClick,
  handleNextClick,
  disabledPrev,
  disabledNext,
  color,
}) => {
  const { translate } = useTranslationHook()
  return (
    <StyledControlsContainer>
      <SliderButtonStyle
        color={color}
        onClick={handlePrevClick}
        disabledPrev={disabledPrev}
      >
        <ControlsPrevIcon /> {translate("PREV")}
      </SliderButtonStyle>
      <SliderButtonStyle
        color={color}
        onClick={handleNextClick}
        disabledNext={disabledNext}
      >
        {translate("NEXT")} <ControlsNextIcon />
      </SliderButtonStyle>
    </StyledControlsContainer>
  )
}

export default QuickStartMobileControls
